import dateFns from 'date-fns'

// import CoreResize from '../../mixins/core-resize'
import AppPage from '../../mixins/app-page'

import AppBtnShare from '../app-btn-share'
import AppImgBg from '../app-img-bg'
import AppImg from '../app-img'
import AppSlideshow from '../app-slideshow'
import AppResume from '../app-resume'


// URL list
import URL from '../../../config.url'


export default
{
    name: 'page-article',

    mixins:
    [
        AppPage
    ],

    components: {
        AppBtnShare,
        AppImgBg,
        AppImg,
        AppSlideshow,
        AppResume
    },

    data()
    {
        return {
            currentURL: '',
            coverIsLoading: true
        }
    },

    created()
    {
        this.currentURL = this.$root.$route.path
    },

    mounted()
    {
        this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
        this._listenImg(this.$el.querySelector('.js-article-content'))
    },

    methods:
    {
        _coverOnLoad()
        {
            this.$el.querySelector('.js-article-cover').classList.remove('is-loading')
        },

        getArticleUrlBySlug(slug)
        {
            return URL.page.article.replace(':slug', slug)
        },

        getTypeById(id)
        {
            return this.contentGlobal.postTypes.find(type => type.id === id)
        },

        formatDate(timeStamp)
        {
            return dateFns.format(timeStamp * 1000, 'dddd DD[.]MM[.]YYYY')
        },

        resumeFormatDate(timestamp)
        {
            return dateFns.format(timestamp * 1000, 'DD[.]MM[.]YYYY [—] h[:]mm[<sup>]a[</sup>]')
        },

        // Force resize after every img loaded (recursive)
        _listenImg(tag)
        {
            for (const child of tag.children)
            {
                this._listenImg(child)
            }

            if (tag.tagName.toLowerCase() === 'img')
            {
                tag.onload = this.onResized
            }
        },

        _onContentResized()
        {
            this.$emit('load', this)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-article/script.js